import classNames from 'classnames';
import React, { Component } from 'react';
import IconButton from '../IconButton';
import { GASpotEventState } from '../../organisms/NegotiationCountList';
import { REFRESH_BTN_COMMON } from '../../../Common';

export interface RefreshButtonProps {
  onclick: () => void;
  isLoading?: boolean;
  gaSpotEvent?: GASpotEventState;
}

class RefleshButton extends Component<RefreshButtonProps, {}> {
  componentDidMount(): void {
    const { gaSpotEvent, isLoading } = this.props;

    if (!gaSpotEvent || isLoading) return;
    document.querySelector(`.${gaSpotEvent.className}`)?.setAttribute('onclick', `${gaSpotEvent.spotEvent}`);
  }
  render() {
    const { isLoading } = this.props;

    return (
      <IconButton
        data-testid='refreshData'
        data-testid-e2e='refreshData'
        className={classNames({
          'icon-button--rotate': isLoading,
          [REFRESH_BTN_COMMON.CLASSNAME]: !isLoading,
        })}
        disabled={isLoading}
        icon='autorenew'
        onClick={() => this.props.onclick()}
      />
    );
  }
}

export default RefleshButton;
